import { copyTextToClipboard } from '@lessonup/client-integration';
import { Button, IconCheck, IconLinkAdd, styled, TextField } from '@lessonup/ui-components';
import { asError } from '@lessonup/utils';
import React, { useState } from 'react';
import { useClipboardErrorHandler } from '../../../../hooks/useClipboardErrorHandler';
import { useEditorTranslation } from '../../../../hooks/useEditorTranslation';

interface CopyPanelProps {
  name?: string;
  value: string;
  onCopyClick?: () => void;
}
export function CopyPanel({ name = '', value, onCopyClick }: CopyPanelProps) {
  const { t } = useEditorTranslation();
  const { handleClipboardError } = useClipboardErrorHandler();
  const [wasCopied, setWasCopied] = useState(false);

  const handleCopyLink = async () => {
    if (!value) {
      return;
    }

    try {
      await copyTextToClipboard(value);
      setWasCopied(true);
      onCopyClick?.();
    } catch (error) {
      handleClipboardError(asError(error));
    }
  };

  return (
    <StyledTextField
      size="medium"
      label={name}
      type="text"
      value={value}
      disabled
      endSlot={
        <Button
          buttonShape="rect"
          size="medium"
          buttonType="secondary"
          iconStart={wasCopied ? <IconCheck /> : <IconLinkAdd />}
          onClick={handleCopyLink}
          disabled={!value}
        >
          {wasCopied ? t('shareLesson.copied') : t('shareLesson.copyLink')}
        </Button>
      }
    />
  );
}

const StyledTextField = styled(TextField)`
  flex: 1;
`;
